import React, { FC } from 'react'
import WithdrawalActivityContainer from 'containers/WithdrawalActivity'

const WithdrawalActivityPage: FC = () => <WithdrawalActivityContainer />

export default WithdrawalActivityPage
